import { ANONYMIZED_ROLE_SYSTEM } from 'constants/user.constants';
import { InternalTransferDetails, UserRole } from 'enums';

import { Asset } from './asset.type';

export enum InternalTransferStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Completed = 'completed',
}

export type InternalTransfer = {
  id: string;
  senderUserId: string;
  senderUser: {
    name?: string;
    role?: UserRole | typeof ANONYMIZED_ROLE_SYSTEM;
  };
  senderAssetId: string;
  senderAsset?: Asset;
  recipientUserId?: string;
  recipientUser?: {
    name?: string;
    role?: UserRole | typeof ANONYMIZED_ROLE_SYSTEM;
  };
  recipientAssetId?: string;
  recipientAsset?: Asset;
  createdAt: string;
  amount: number;
  status: InternalTransferStatus;
  details?: InternalTransferDetails;
  category?: string;
  comment?: string;
};
